import ArrowLeftIcon from '@/assets/images/icons/arrow-left.svg';
import ClearIcon from '@/assets/images/icons/clear-icon.svg';
import React from 'react';
import { TouchableOpacity } from 'react-native';
import { XStack, YStack } from 'tamagui';
import { CardTitle } from '@/components/ui/Typography';
import { ConfettiAnimation } from './ConfettiAnimation';
import { LessonSuggestions } from './LessonSuggestions';
import { Lesson } from '../types';

interface LessonCompletionContentProps {
  suggestions: Lesson[];
  onClose: () => void;
  isMobile?: boolean;
  showCloseButton?: boolean;
  onSuggestionPress?: (lesson: Lesson) => void;
  onBack?: () => void;
  courseName?: string;
}

export const LessonCompletionContent: React.FC<LessonCompletionContentProps> = ({
  suggestions,
  onClose,
  isMobile = false,
  showCloseButton = true,
  onSuggestionPress,
  onBack,
  courseName
}) => {
  return (
    <YStack
      ai="center"
      gap="$3"
      bg="white"
      borderRadius="$6"
      shadowRadius={10}
      width={'100%'}
      height={'100%'}
      overflow="hidden"
      padding={16}
    >
      {/* Confetti Animation */}
      <ConfettiAnimation shouldShow={true} />

      {/* Header actions: optional Back (left) and Close (right) */}
      {(showCloseButton || onBack) && (
        <XStack w="100%" jc="space-between" ai="center">
          <XStack ai="center" gap="$2">
            <TouchableOpacity onPress={onBack} disabled={!onBack}>
            {onBack ? <ArrowLeftIcon width={22} height={22} /> : <></>}
            </TouchableOpacity>
            {courseName ? (
              <TouchableOpacity onPress={onBack} disabled={!onBack}>
                <CardTitle color="#0D0D0D">
                  {courseName}
                </CardTitle>
              </TouchableOpacity>
            ) : null}
          </XStack>
          {showCloseButton && (
            <TouchableOpacity onPress={onClose}>
              <ClearIcon width={22} height={22} />
            </TouchableOpacity>
          )}
        </XStack>
      )}

      {/* Lesson completed banner */}
      <YStack
        bg="#DEFAEB"
        borderColor="#2CC074"
        borderWidth={1}
        ai="center"
        width={'80%'}
        borderRadius={12}
        my={"$2"}
        p={12}
      >
        <CardTitle color={'#1E1E1E'}>
          Lesson Completed!
        </CardTitle>
      </YStack>

      {/* Suggestions */}
      <LessonSuggestions 
        suggestions={suggestions}
        onSuggestionPress={onSuggestionPress}
      />
    </YStack>
  );
};
